import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IFailedPayload } from 'redux/types/Call.types';

export interface AgentPerformanceMetrics {
  name: string;
  teamLeader: string;
  totalCalls: number;
  totalConnectedCalls: number;
  totalNotConnectedCalls: number;
  loginTime: string;
  logoutTime: string;
  totalLoginHours: string;
  idealDuration: string;
  callDuration: string;
  totalBreak: string;
  nonProductiveAux: string;
  breakTime?: string | null;
  talkTime?: string;
  wrapTime?: string | null;
  idleTime?: string | null;
  email: string;
}

export interface AgentPerformanceMetricsResponse {
  data: AgentPerformanceMetrics[];
  totalCount: number;
  filteredCount: number;
}

export interface AgentPerformanceCallMetricsResponse {
  totalCalls: number;
  totalAgents: number;
  totalNotConnectedCalls: {
    percentage: number;
    totalCalls: number;
  };
  totalConnectedCalls: {
    percentage: number;
    totalCalls: number;
  };
  totalAccounts: number;
  untouchedAccounts: number;
}

export interface AgentPerformanceCallMetricsRequest {
  supervisorId: string;
  startDate: string;
  endDate: string;
  searchText?: string;
  limit: number;
  offset: number;
}

export interface AgentPerformanceState {
  error: IFailedPayload | null;
  loading: boolean;
  performanceStats: AgentPerformanceCallMetricsResponse | null;
  performanceMetrics: AgentPerformanceMetricsResponse | null;
  performanceStatsLoading: boolean;
  performanceMetricsLoading: boolean;
}

export const agentPerformanceInitialState: AgentPerformanceState = {
  error: null,
  loading: false,
  performanceStats: null,
  performanceMetrics: null,
  performanceStatsLoading: false,
  performanceMetricsLoading: false,
};

const allAgentPerformanceSlice = createSlice({
  name: 'performance/allAgentPerformance',
  initialState: agentPerformanceInitialState,
  reducers: {
    fetchAgentPerformanceStats: (
      state,
      _action: PayloadAction<AgentPerformanceCallMetricsRequest>
    ) => {
      state.performanceStatsLoading = true;
      state.error = null;
    },
    fetchAgentPerformanceStatsSuccess: (
      state,
      action: PayloadAction<AgentPerformanceCallMetricsResponse>
    ) => {
      state.performanceStatsLoading = false;
      state.performanceStats = action.payload;
    },
    fetchAgentPerformanceStatsFailure: (
      state,
      action: PayloadAction<IFailedPayload>
    ) => {
      state.error = action.payload;
      state.performanceStatsLoading = false;
    },
    fetchAgentPerformanceMetrics: (
      state,
      _action: PayloadAction<AgentPerformanceCallMetricsRequest>
    ) => {
      state.performanceMetricsLoading = true;
      state.error = null;
    },
    fetchAgentPerformanceMetricsSuccess: (
      state,
      action: PayloadAction<AgentPerformanceMetricsResponse>
    ) => {
      state.performanceMetricsLoading = false;
      state.performanceMetrics = action.payload;
    },
    fetchAgentPerformanceMetricsFailure: (
      state,
      action: PayloadAction<IFailedPayload>
    ) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchAgentPerformanceStats,
  fetchAgentPerformanceStatsSuccess,
  fetchAgentPerformanceStatsFailure,
  fetchAgentPerformanceMetrics,
  fetchAgentPerformanceMetricsSuccess,
  fetchAgentPerformanceMetricsFailure,
} = allAgentPerformanceSlice.actions;

export default allAgentPerformanceSlice.reducer;
